module.exports = __webpack_public_path__ + "img/map-pin-x-inside.7ad54b11.svg";